import { AfterViewChecked, ChangeDetectorRef, Component } from '@angular/core';
import { CustomerService } from '@services/customers/customer.service';
import { OrganisationCustomerService } from '@services/customers/organisation-customer.service';
import { PageAction } from '../../components/page-actions/page-actions.component';
import { Router } from '@angular/router';
import { MessengerService } from '@services/messenger/messenger.service';

@Component({
    selector: 'app-analytics',
    templateUrl: './analytics.component.html',
    styleUrls: ['./analytics.component.scss'],
    providers: [OrganisationCustomerService, CustomerService],
    standalone: false
})

export class AnalyticsComponent implements AfterViewChecked {
  public customer;
  public pageActions: PageAction[];
  public customerColumns = [
    { prop: 'company' },
    { prop: 'touch2015Count' },
    { prop: 'touch2goCount' }
  ];

  public customerSearchColumns = [{prop: 'company'}];
  public orgCustomerSearchColumns = [{prop: 'organisationName'}];

  public orgCustomerColumns = [
    { prop: 'organisationName' },
    { prop: 'priceModel' },
    { prop: 'name.firstName', name: 'firstname' },
    { prop: 'name.lastName', name: 'lastname' }
  ];

  constructor(public customerService: CustomerService, public organisationCustomerService: OrganisationCustomerService,
              private cdRef: ChangeDetectorRef, private router: Router, private ms: MessengerService
  ) {
    const privileges = this.ms.$activePrivileges.getValue();
    for (const priv of privileges) {
      if (priv.privilegeName === 'superadmin' && priv.value === 'analytics') {
        return;
      }
    }
    if (this.ms.$activeOrganisation.getValue().ibex3customerId) {
      this.onDetailCustomer(this.ms.$activeOrganisation.getValue().ibex3customerId);
    } else if (this.ms.$activeOrganisation.getValue().organisationCustomerId) {
      this.onDetailCustomer(this.ms.$activeOrganisation.getValue().organisationCustomerId);
    }
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  selectCustomer(customer) {
    this.customer = customer;
  }

  onDetailCustomer(event: any) {
    let id;
    if (event && event.row && event.row._id) {
      id = event.row._id;
    } else if (typeof event === 'string') {
      id = event;
    }
    this.router.navigate(['analytics', 'ibex3', id]);
  }

  onDetailOrgCustomer(event: any) {
    let id;
    if (event && event.row && event.row._id) {
      id = event.row._id;
    } else if (typeof event === 'string') {
      id = event;
    }
    this.router.navigate(['analytics', 'ibex4', id]);
  }
}
